import styled from '@emotion/styled';

import RestoreIcon from '@/assets/icons/icon_restore.svg';
import TrashIcon from '@/assets/icons/icon_trash.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const Button = styled.button((props: { disabled: boolean }) =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: ['35px', '35px', '40px', '40px'],
    height: ['35px', '35px', '40px', '40px'],
    border: '1px solid #848583',
    borderRadius: '50%',
    opacity: props.disabled ? defaultTheme.button.opacity.disabled : 1,
    ...(props.disabled ? {} : hoverOpacity),
  }),
);

export const Trash = styled.i(() =>
  mq({
    width: '14px',
    height: '16px',
    backgroundImage: `url(${TrashIcon})`,
  }),
);

export const Restore = styled.i(() =>
  mq({
    width: '14px',
    height: '16px',
    backgroundImage: `url(${RestoreIcon})`,
  }),
);
